/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Duration_To_ExportInputs */



/**
* | output |
* | --- |
* | "Duration to export (min)" |
*
* @param {Intervention_Plan_Duration_To_ExportInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_duration_to_export = /** @type {((inputs?: Intervention_Plan_Duration_To_ExportInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Duration_To_ExportInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Duration to export (min)")
	return /** @type {LocalizedString} */ ("Durée à exporter (min)")
});